var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEmail, IsOptional, MaxLength } from 'class-validator';
/**
 * `POST /users/:id/invite`, „Einladen“ for any role (#1830). A patient's invite
 * goes to the Contact address and ignores `email`. Staff have no Contact
 * address (#1792), so a staff member without a login is invited at `email`.
 */
export class SendInviteDto {
    email;
}
__decorate([
    IsOptional(),
    IsEmail(),
    MaxLength(255),
    __metadata("design:type", Object)
], SendInviteDto.prototype, "email", void 0);
//# sourceMappingURL=send-invite.dto.js.map